import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppBaseComponent } from '@shared/components/app-component-base';
import { OnboardingService } from '@shared/services/onboarding/onboarding.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-onboarding-v2',
  templateUrl: './onboarding-v2.component.html',
  styleUrls: ['./onboarding-v2.component.scss'],
})
export class OnboardingV2Component extends AppBaseComponent {
  private onboardingService: OnboardingService = inject(OnboardingService);
  public onboardingProgress: BehaviorSubject<number> = this.onboardingService.getOnboardingPercentage();

  private route: ActivatedRoute = inject(ActivatedRoute);

  get hasChildRoutes(): boolean {
    return true;
  }
}
